import { cn } from '@/lib/utils';
import { STATUS_COLOR_CLASS } from '@/styles/statusColors';
import {
  FEEDBACK_STATUS_LABELS,
  FEEDBACK_STATUS_TONE,
  RESOLVE_STATUS_ICONS,
} from '../constants/feedback.constants';
import { RESOLVE_STATUS, type ResolveStatus } from '../types/feedback.types';

interface ResolveStatusSelectorProps {
  value: ResolveStatus;
  onChange: (status: ResolveStatus) => void;
}

export function ResolveStatusSelector({ value, onChange }: ResolveStatusSelectorProps) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {RESOLVE_STATUS.map((status) => {
        const Icon = RESOLVE_STATUS_ICONS[status];
        const isActive = value === status;
        return (
          <button
            key={status}
            type="button"
            onClick={() => onChange(status)}
            className={cn(
              'flex flex-col items-center justify-center gap-1.5 rounded-lg border px-2 py-3 text-center text-2xs sm:px-3 sm:text-xs font-medium transition-all cursor-pointer',
              isActive
                ? cn(
                    STATUS_COLOR_CLASS[FEEDBACK_STATUS_TONE[status]],
                    'border-current ring-1 ring-current/10 shadow-sm',
                  )
                : 'border-border text-muted-foreground hover:bg-accent hover:text-foreground hover:border-foreground/20',
            )}
          >
            <Icon className="size-5" />
            {FEEDBACK_STATUS_LABELS[status]}
          </button>
        );
      })}
    </div>
  );
}
